import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=ed97b7c4&"
import script from "./Datatables.vue?vue&type=script&lang=ts&"
export * from "./Datatables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports